<div class="page-layout carded left-sidenav toolbar-fixed-layout">

  <!-- HEADER -->

  <mat-sidenav-container>
    <div class="center">
      <div class="content-card mat-white-bg">
        <div class="content flex flex-col">

          <form (keydown.enter)="$event.preventDefault()" class="p-30 flex flex-col full-grow-no-shrink-no-basis"
                fusePerfectScrollbar
                [formGroup]="inputForm">

            <div class="flex flex-row">

              <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
                <mat-label>Choose Country</mat-label>
                <input formControlName="country" matInput placeholder="Choose Country"
                       (click)="showCountryDialogue()" readonly>
              </mat-form-field>

              <mat-form-field appearance="outline" class="m-l-20 full-grow-no-shrink-no-basis">
                <mat-label>Taxable Income (in local currency)</mat-label>
                <input formControlName="taxableIncome" (blur)="updateMemo('taxableIncome')" matInput
                       placeholder="Taxable Income (in local currency)"/>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <mat-checkbox formControlName="isCustom" class="m-b-15">
                <span>Change Default Corporate Tax Rates</span>
              </mat-checkbox>
              <div class="flex flex-row">

                <mat-form-field appearance="outline" class="m-r-20">
                  <mat-label>Statutory Tax Rate</mat-label>
                  <input formControlName="statutoryTaxRate" (blur)="updateMemo('statutoryTaxRate')" matInput
                         placeholder="Statutory Tax Rate"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="m-r-20">
                  <mat-label>Surtax Based on Statutory Tax</mat-label>
                  <input formControlName="surtaxBasedonStatutoryTax" (blur)="updateMemo('surtaxBasedonStatutoryTax')"
                         matInput placeholder="Surtax Based on Statutory Tax"/>
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-20">
                  <mat-label>Surtax Based On Taxable Income</mat-label>
                  <input formControlName="surtaxBasedonTaxableIncome" (blur)="updateMemo('surtaxBasedonTaxableIncome')"
                         matInput placeholder="Surtax Based on Taxable Income"/>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Surtax Deductable From Taxable Income</mat-label>
                  <input formControlName="surtaxDeductiblefromTaxableIncome"
                         (blur)="updateMemo('surtaxDeductiblefromTaxableIncome')" matInput
                         placeholder="Surtax Deductable from Taxable Income"/>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </mat-sidenav-container>

</div>
